/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Hook to prevent window scroll during inner scrolling
 *
 * @author Anton Panasenko
 * @version 1.4.0
 * @since 1.3.0
 */

import { RefObject, useEffect } from 'react';

export function usePreventWindowScroll(componentRef: RefObject<any>) {
    useEffect(() => {
        window.addEventListener('wheel', wheelHandler, { passive: false });
        return () => {
            window.removeEventListener('wheel', wheelHandler, true);
        };
    }, []);

    const wheelHandler = (event: WheelEvent) => {
        if (componentRef.current && componentRef.current.contains(event.target as Node)) {
            if (reachedBorder(componentRef.current, event.deltaY)) {
                event.preventDefault();
            }
        }
    };

    const reachedBorder = (element: Element, deltaY: number): boolean => {
        const isElementBottom: boolean =
            element.scrollHeight - element.scrollTop === element.clientHeight && deltaY > 0;
        const isElementTop: boolean = element.scrollTop === 0 && deltaY < 0;
        return isElementBottom || isElementTop;
    };
}
